import React, { useRef, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import "./contact-us.css";
import emailjs from 'emailjs-com';
import { useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet';

const ContactUs = () => {
  useEffect(() => {
    // ElfSight Widget Setup
    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.setAttribute("data-use-service-core", "");
    script.defer = true; 
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const form = useRef();
  const navigate = useNavigate();

  const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const sendEmail = (e) => {
    e.preventDefault();

    if (!validateEmail(form.current.useremail.value)) {
      alert("Please enter a valid email address");
      return;
    }

    emailjs
      .sendForm(
        "service_m6apr1s",
        "template_1js3ywy",
        form.current,
        "5jHtz5YTo4yK5yAXW"
      )
      .then((response) => {
        console.log("Email sent:", response);
        form.current.reset();
        navigate("/thank-you-contact");
      })
      .catch((error) => {
        console.error("Email error:", error);
      });
  };

  return (
    <>
      <Helmet>
        <title>Contact Us | The Rustic Paths</title>
        <meta 
          name="description" 
          content="Get in touch with us today to learn more about our private driver services in India. We offer a variety of tour packages and services to suit your budget and interests. Contact us to book your private driver today!" 
        />
        <meta 
          name="keywords" 
          content="contact us, The Rustic Paths, book a private driver, tour packages India" 
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.youtube.com/watch?v=8b2zj7fHQ5s" />
      </Helmet>
      <section>
        <Container>
          <Row>
            <Col lg="8">
              <div className="contact-us__content mb-5">
                <div className="contact-us__form">
                  <h2>Contact Us</h2>
                  <form ref={form} onSubmit={sendEmail}>
                    <div className="form-group">
                      <label htmlFor="name">Name</label>
                      <input
                        type="text"
                        id="name"
                        name="from_name"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="email">Email</label>
                      <input
                        type="email"
                        id="email"
                        name="useremail"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="message">Message</label>
                      <textarea
                        id="message"
                        name="message"
                        required
                      ></textarea>
                    </div>
                    <button type="submit" className="submit-button">
                      Submit
                    </button>
                  </form>
                </div>
              </div>
            </Col>
            <Col lg="4">
              <div className="gmb-profile">
                <h3>Visit Us</h3>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1850953.7783997757!2d72.93878027218017!3d25.029183414990985!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396daf63eddfa573%3A0x969ffa82810707ab!2sJaipur%20Sightseeing%20Tours%20%7C%20The%20Rustic%20Paths!5e0!3m2!1sen!2sin!4v1728441452753!5m2!1sen!2sin"
                  width="100%"
                  height="250"
                  style={{ border: 0 }}
                  allowFullScreen="true"
                  loading="lazy"
                ></iframe>
              </div>
            </Col>
            <Col lg="12">
              {/* Add the ElfSight testimonial widget div */}
              <div className="elfsight-app-67d8eea9-b408-49ad-8765-9edf92c75e9a"></div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ContactUs;
